export default "__VITE_ASSET__CHsGF9ec__"